"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _muiDatatables = require("mui-datatables");

var _muiDatatables2 = _interopRequireDefault(_muiDatatables);

var _styles = require("@material-ui/core/styles");

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataTable = function (_React$Component) {
  (0, _inherits3.default)(DataTable, _React$Component);

  function DataTable() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DataTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call.apply(_ref, [this].concat(args))), _this), _this.getMuiTheme = function () {
      var _overrides;

      return (0, _styles.createMuiTheme)({
        overrides: (_overrides = {
          MuiTableHead: {
            root: { fontSize: "13px", fontWeight: "bold" }
          },
          MUIDataTableSelectCell: {
            headerCell: {
              backgroundColor: "#e8e8e8",
              fontSize: "13px",
              fontWeight: "bold",
              color: "white"
            }
          },
          MUIDataTableHeadCell: {
            fixedHeader: {
              backgroundColor: "#e8e8e8",
              fontSize: "13px",
              fontWeight: "bold",
              color: "white"
            }
          }
        }, (0, _defineProperty3.default)(_overrides, "MUIDataTableHeadCell", {
          fixedHeaderCommon: {
            backgroundColor: "#e8e8e8",
            color: "white"
          }
        }), (0, _defineProperty3.default)(_overrides, "MuiTableCell", {
          body: { fontSize: 14 },
          head: {
            fontSize: 14,
            color: "rgba(0, 0, 0, 0.8700000048)",
            fontWeight: 700,
            background: "#e8e8e8"
          },
          root: { padding: "4px 5px 4px 12px" }
        }), (0, _defineProperty3.default)(_overrides, "MuiTypography", {
          caption: { fontSize: "12px" }
        }), _overrides),
        shadows: ["none"]
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DataTable, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          columns = _props.columns,
          data = _props.data,
          options = _props.options,
          title = _props.title,
          rest = (0, _objectWithoutProperties3.default)(_props, ["columns", "data", "options", "title"]);
      // Set the scrollY and scrollX options for the DataTable
      // const defaultOptions = {
      //   ...options,
      //   scrollY: "400px", // Set the height of the scrollable body here
      //   scrollX: true, // Enable horizontal scrolling
      //   fixedHeader: true, // Freeze the header
      // };

      return _react2.default.createElement(
        _styles.MuiThemeProvider,
        { theme: this.getMuiTheme() },
        _react2.default.createElement(_muiDatatables2.default, (0, _extends3.default)({ columns: columns, data: data, title: title, options: (0, _extends3.default)({}, options, { fixedHeader: true }) }, rest))
      );
    }
  }]);
  return DataTable;
}(_react2.default.Component);

exports.default = DataTable;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/components/DataTable/index.js
// module id = 2131
// module chunks = 1137